// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__2R3u6","title":"FrontImage_title__2UAvC"};